export default "__VITE_ASSET__CUGpuSwj__"